import { Button } from "@material-ui/core";
import React, { useState } from "react";

import { LogFilterRequest } from "../../../rest/requestObjects/eventLogRequest";

import { AlarmAcknowledgementDialog } from "./AlarmAcknowledgementDialog";

interface Props {
    siteId: number | null | undefined;
    organizationId: number | null | undefined;
    logFilterRequest: LogFilterRequest;
    onSuccess: () => void;
}

export function AcknowledgeAllAlarmsButton({
    siteId,
    organizationId,
    onSuccess,
    logFilterRequest,
}: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);

    return (<>
        <Button
            variant="contained"
            disabled={!siteId}
            color="inherit"
            onClick={() => setDialogOpen(true)}
        >
            Acknowledge All
        </Button>

        <AlarmAcknowledgementDialog
            open={dialogOpen}
            onSuccess={onSuccess}
            onClose={() => setDialogOpen(false)}
            siteId={siteId}
            organizationId={organizationId}
            logFilterRequest={logFilterRequest}
        />
    </>);
}
